import React, { useRef } from 'react'

import { usePermissions } from '../../../hooks'

/**
 * Wrapper component that shows/hides menu items based on user permissions
 * @param {string[]} requiredPermissions - Array of permission names (user needs ANY of these)
 * @param {React.ReactNode} children - The menu item content to render if permitted
 */
export function ProtectedMenuItem({ requiredPermissions, children }) {
  const { hasPermission, loading } = usePermissions(requiredPermissions)
  const lastKnownPermission = useRef(null)

  if (!loading) {
    lastKnownPermission.current = hasPermission
  }

  // On initial load (no cached result yet), hide until first check completes
  if (loading && lastKnownPermission.current === null) return null

  // During re-fetches use the last known state to avoid flicker
  const effectivePermission = loading ? lastKnownPermission.current : hasPermission

  if (!effectivePermission) return null

  return children
}
